export default __webpack_public_path__ + "static/media/infinite.02216684.png";